import React from "react";
import {Field, reduxForm} from "redux-form/immutable";
import {fromJS, List, Map} from "immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import BooleanInputField from "../../../components/forms/BooleanInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import TelephoneInputField from "../../../components/forms/TelephoneInputField";
import normalizePhoneNr, {getCompletePhoneNrOrNothing} from "../../../lib/TelephoneNormalizer";
import FormError from "../../../components/forms/FormError";
import {validatePresence} from "../../../lib/Validators";

// A partner is a client (we dispatch stock to it), a supplier (we buy from
// it), or both.
export const ROLE_OPTIONS = fromJS([
  {id: "client", label: "Client"},
  {id: "supplier", label: "Supplier"},
  {id: "client,supplier", label: "Client and supplier"},
]);

export function rolesToOption(roles) {
  return List(roles || []).join(",");
}

export function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "name");
  errors = validatePresence(errors, values, "roles");
  return errors.toJS();
}

export function prepareValuesForSubmission(values) {
  return Map({
    name: (values.get("name") || "").trim(),
    roles: List((values.get("roles") || "").split(",").filter((role) => role)),
    contactName: values.get("contactName") || "",
    email: values.get("email") || "",
    // "+46" alone (a dial code, no number) is no phone number.
    phone: getCompletePhoneNrOrNothing((values.get("phone") || "").trim()),
    notes: values.get("notes") || "",
    active: values.get("active") === true || values.get("active") === "true",
  });
}

const PartnerForm = (props) => {
  const {errors, handleSubmit, submitting} = props;
  const submitLabel = submitting ? "Standby..." : "Save";

  return (
    <form onSubmit={handleSubmit}>
      <div className="fields">
        <FormFieldsTable>
          <Field label="Name" name="name" component={TextInputField} serverError={errors.name} />
          <Field label="Role" name="roles" component={DropDownInputField} data={ROLE_OPTIONS}
            valueKey="id" titleKey="label" showBlank={true} serverError={errors.roles} />
          <Field label="Contact" name="contactName" component={TextInputField} serverError={errors.contactName} />
          <Field label="Email" name="email" component={TextInputField} serverError={errors.email} />
          <Field label="Phone" name="phone" mode="" normalize={normalizePhoneNr} component={TelephoneInputField} serverError={errors.phone} />
          <Field label="Active" name="active" component={BooleanInputField} serverError={errors.active} />
          <Field label="Notes" name="notes" component={TextAreaInputField} rows={3} serverError={errors.notes} />
        </FormFieldsTable>
      </div>
      <FormError error={errors._error} />
      <div className="buttons">
        <ActionButton label="Cancel" active={!submitting} onClick={props.onCancel} />
        <ActionButton label={submitLabel} onClick={handleSubmit(values => props.onSubmit(values))} active={!submitting} />
      </div>
    </form>
  );
}

export default reduxForm({form: "PartnerForm"})(PartnerForm);
